/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:21
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-07 18:16:17
 * @FilePath: \ioc_base\src\modules\personAR\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  {
    path: '/personAccessRecord', // 人员通行授权
    name: 'personAccessRecord',
    component: () => import('./pages/Home'),
    redirect: '/personAccessRecord/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index', // 
        name: 'personAccessRecordIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes